import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {TranslateConfigService} from './translate-config.service';

@Injectable({providedIn: 'root'})

export class HttpService {
  private apiUrl = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private translateConfigService: TranslateConfigService
  ) {
  }

  /**
   * Construye headers base para peticiones API.
   * El token Authorization se añade vía authInterceptor (no aquí, para evitar duplicación).
   */
  private getHeaders(customHeaders?: HttpHeaders): HttpHeaders {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json, text/plain, */*',
      'Accept-Language': this.translateConfigService.getCurrentLanguage()
    });

    if (customHeaders) {
      customHeaders.keys().forEach(key => {
        headers = headers.set(key, customHeaders.get(key) as string);
      });
    }

    return headers;
  }

  get<T>(endpoint: string, customHeaders?: HttpHeaders): Observable<T> {
    return this.http.get<T>(`${this.apiUrl}/${endpoint}`, {
      headers: this.getHeaders(customHeaders)
    });
  }

  post<T>(endpoint: string, data: any, customHeaders?: HttpHeaders): Observable<T> {
    return this.http.post<T>(`${this.apiUrl}/${endpoint}`, data, {
      headers: this.getHeaders(customHeaders)
    });
  }

  put<T>(endpoint: string, data: any, customHeaders?: HttpHeaders): Observable<T> {
    return this.http.put<T>(`${this.apiUrl}/${endpoint}`, data, {
      headers: this.getHeaders(customHeaders)
    });
  }

  patch<T>(endpoint: string, data: any, customHeaders?: HttpHeaders): Observable<T> {
    return this.http.patch<T>(`${this.apiUrl}/${endpoint}`, data, {
      headers: this.getHeaders(customHeaders)
    });
  }

  delete<T>(endpoint: string, customHeaders?: HttpHeaders): Observable<T> {
    return this.http.delete<T>(`${this.apiUrl}/${endpoint}`, {
      headers: this.getHeaders(customHeaders)
    });
  }
}
